var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.72,
    height: 62.823,
    viewBox: "0 0 57.72 62.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TrashCan",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "translate(7.681 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(10.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M-4852.089-5241.977a1.618,1.618,0,0,1-1.618-1.618v-4.551a2.777,2.777,0,0,0-2.775-2.773h-9a2.777,2.777,0,0,0-2.775,2.773v4.551a1.618,1.618,0,0,1-1.618,1.618,1.618,1.618,0,0,1-1.618-1.618v-4.551a6.018,6.018,0,0,1,6.012-6.009h9a6.018,6.018,0,0,1,6.012,6.009v4.551A1.618,1.618,0,0,1-4852.089-5241.977Z",
    transform: "translate(4871.499 5254.154)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M-4907.574-5096.339H-4938.1a5.922,5.922,0,0,1-5.915-5.915v-38.912a1.618,1.618,0,0,1,1.618-1.617,1.618,1.618,0,0,1,1.618,1.617v38.912a2.682,2.682,0,0,0,2.679,2.679h30.528a2.682,2.682,0,0,0,2.679-2.679v-38.912a1.617,1.617,0,0,1,1.618-1.617,1.617,1.617,0,0,1,1.618,1.617v38.912A5.921,5.921,0,0,1-4907.574-5096.339Z",
    transform: "translate(4944.018 5159.163)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4",
    transform: "translate(0 9.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M-4940.138-5188.9h-54.484a1.619,1.619,0,0,1-1.618-1.618,1.618,1.618,0,0,1,1.618-1.617h54.484a1.618,1.618,0,0,1,1.618,1.617A1.619,1.619,0,0,1-4940.138-5188.9Z",
    transform: "translate(4996.24 5192.132)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(21.285 15.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M-4849.9-5063.262a1.618,1.618,0,0,1-1.618-1.618v-22a1.618,1.618,0,0,1,1.618-1.618,1.618,1.618,0,0,1,1.618,1.618v22A1.618,1.618,0,0,1-4849.9-5063.262Z",
    transform: "translate(4851.517 5088.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M-4768.9-5063.262a1.617,1.617,0,0,1-1.618-1.618v-22a1.618,1.618,0,0,1,1.618-1.618,1.618,1.618,0,0,1,1.618,1.618v22A1.617,1.617,0,0,1-4768.9-5063.262Z",
    transform: "translate(4782.43 5088.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/TrashCan.d3f49779.svg";
export { ForwardRef as ReactComponent };